import neApi from './api';

export default {
  // getUserInfo: (params?: any) => apiGet('/gateway/api/v1/user/info', params)
  getUserInfo: (params?: any) => {
    return neApi.get('/wx/app/evaluation/user', params)
  }
};
